import React from 'react';
import {Menu} from 'components/customer/RoomPlanner/components/Menu';
import {useRoomPlannerLeftMenu} from 'components/customer/RoomPlanner/helper/useRoomPlannerLeftMenu';
import useUI from 'shared/useUI';
import {SidebarStatus, SidebarBehaviour} from 'store/customer/UISlice';
import {BaseConfig} from 'config';
import {isMobile} from 'react-device-detect';

interface ContextMenuProps {
    mobileView?: boolean;
}

export const ContextMenu = ({mobileView = false}: ContextMenuProps) => {
    const {isRoomPlannerPage} = useRoomPlannerLeftMenu();
    const {leftSidebar, leftSidebarBehaviour} = useUI();

    return (
        <>
            {!!isRoomPlannerPage ? (
                <Menu
                    isCollapsed={
                        leftSidebar != SidebarStatus.OPEN &&
                        leftSidebarBehaviour === SidebarBehaviour.TOGGLE
                    }
                    menu={BaseConfig.USER_CUSTOMER.roomPlannerMenu}
                    mobileView={mobileView}
                />
            ) : null}
            {!!isRoomPlannerPage && !isMobile ? (
                <Menu
                    isCollapsed={
                        leftSidebar != SidebarStatus.OPEN &&
                        leftSidebarBehaviour === SidebarBehaviour.TOGGLE
                    }
                    isFooter={true}
                    menu={BaseConfig.USER_CUSTOMER.roomPlannerBottomMenu}
                />
            ) : null}
        </>
    );
};
